export const supportURL: string = 'support@contentoo.com';
